import React, { CSSProperties, ReactNode } from 'react';
import { FontColor } from 'shared/styles/typography';
import './PrimaryButton.scss';

interface PrimaryButtonInterface {
  children: ReactNode;
  onClick?: () => void;
  style?: CSSProperties;
  textColor?: FontColor;
  backgroundColor?: FontColor;
  disabled?: boolean;
  className?: string;
  type? : JSX.IntrinsicElements['button']['type'];
}

const PrimaryButton = ({
  children,
  onClick,
  style,
  textColor = FontColor.SecondaryMain,
  backgroundColor = FontColor.PrimaryMain,
  disabled,
  className,
  type
}: PrimaryButtonInterface) => {
  const classNames = `Primary-Button Primary-Button__text-color--${textColor} Primary-Button__background-color--${backgroundColor} ${className}`;

  return (
    <button className={classNames} onClick={onClick} disabled={disabled} style={style} type={type}>
      {children}
    </button>
  );
};

export default PrimaryButton;
